// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"9f68e116","631":"d3d09ec6","681":"232fdf68"}[chunkId] + ".chunk.css";
};